import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap";
import {
  GET_RP_BALANCE,
  GET_RP_BALANCE_EAST,
  GET_RP_BALANCE_TOTAL,
  GET_RP_BALANCE_WEST,
  GET_RP_OVERUSE_CODE,
  GET_RP_OVERUSE_CODE_DATA,
  GET_RP_OVERUSE_SHIPPER,
  GET_SHIPPER,
} from "../../../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import ChartOnshore from "./ChartOnshore";
import OveruseByContact from "./OveruseByContact";
import OveruseByShipper from "./OveruseByShipper";
import PropTypes from "prop-types";
import Select from "react-select";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SectionCapacityOveruse(props) {
  // console.log(props);
  const dispatch = useDispatch();

  const searchDate = { SELECT_DATE: props.date };

  const [flagShowContact, setFlagShowContact] = useState({
    FLAG_SHOW_TABLE: 1,
  })

  // DropDown Search
  const [dropDownShipper, setDropDownShipper] = useState({
    label: "",
    value: "",
    OVERUSECODE_PID: "",
  });
  const [listShipper, setListShipper] = useState([]);
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownShipper = selected => {
    setDropDownShipper(selected);
  };
  // Handle Set Value DropDown Search //

  const [overuseDataByContact, setOveruseDataByContact] = useState([]);
  const [contactCount, setContactCount] = useState(0);

  const [shippers, setShippers] = useState([]);
  const [total, setTotal] = useState({ entry: [], exit: [] });
  const [overuseDataEntry, setOveruseDataEntry] = useState([]);
  const [overuseDataExit, setOveruseDataExit] = useState([]);
  const [minMaxTotalList, setMinMaxTotalList] = useState([]);
  const [minMaxEastList, setMinMaxEastList] = useState([]);
  const [minMaxWestList, setMinMaxWestList] = useState([]);
  const [balancingOnshoreEast, setBalancingOnshoreEast] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
  });
  const [balancingOnshoreWest, setBalancingOnshoreWest] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
  });
  const [balancingOnshoreTotal, setBalancingOnshoreTotal] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
  });
  const [balancingGraphData, setBalancingGraphData] = useState([]);

  const [dataCriteriaEast, setDataCriteriaEast] = useState(0);
  const [dataCriteriaWest, setDataCriteriaWest] = useState(0);
  const [dataCriteriaTotal, setDataCriteriaTotal] = useState(0);

  useEffect(() => {
    // console.log(shippers)
    setListShipper(
      shippers.map(item => ({ label: item.SHIPPER_NAME, value: item.PID, OVERUSECODE_PID: item.OVERUSECODE_PID }))
    );
  }, [shippers]);

  useEffect(() => {
    if (listShipper.length > 0) {
      setDropDownShipper(listShipper[0]);
    } else {
      setDropDownShipper({ label: "", value: "" });
    }
  }, [listShipper]);
  useEffect(() => {
    getShipperList();
  }, [props.summaryReportPid]);
  useEffect(() => {
    fetchData();
  }, [dropDownShipper]);
  useEffect(() => { }, [props.date]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const getShipperList = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    dispatch(loadingAction.showLoading());
    try {
      let [res1] = await Promise.all([
        post(GET_RP_OVERUSE_CODE, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
      ]);
      let data = res1.data.RPOversureShipperList;

      let shipperList = data.map((item, index) => ({
        OVERUSECODE_PID: item.PID,
        SHIPPER_NAME: item.OVERUSECODE_SHIPPER,
        PID: item.OVERUSECODE_PID,
        PRIORITY_FLAG: item.OVERUSECODE_ORDER,
      }));
      shipperList = [
        ...new Map(shipperList.map(item => [item["PID"], item])).values(),
      ];

      setShippers(shipperList.sort(compare));

    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  // const getShipperList = async () => {
  //   function compare(a, b) {
  //     if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
  //       return -1;
  //     }
  //     if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
  //       return 1;
  //     }
  //     return 0;
  //   }
  //   dispatch(loadingAction.showLoading());
  //   try {
  //     let [res1, res2] = await Promise.all([
  //       post(GET_RP_OVERUSE_SHIPPER, {
  //         SUMMARYREPORT_PID:
  //           props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
  //       }),
  //       post(GET_SHIPPER, {

  //       }),
  //     ]);
  //     let masterCustomerList = res2.data.customerList

  //     let data = res1.data.RPOversureShipperList;

  //     let shipperList = data.map((item, index) => {
  //       let shipperData = masterCustomerList.find((row) => row.CONTACT_CODE == item.OVERUSESHIPPER_NAME)
  //       return {
  //         SHIPPER_NAME: shipperData?.FULL_NAME,
  //         PID: item.OVERUSESHIPPER_PID,
  //         PRIORITY_FLAG: item.OVERUSESHIPPER_ORDER,
  //       }
  //     });

  //     shipperList = [
  //       ...new Map(shipperList.map(item => [item["PID"], item])).values(),
  //     ];

  //     setShippers(shipperList.sort(compare));
  //   } catch (error) {
  //     dispatch(messageAction.showMessage(error.message));
  //   }
  //   dispatch(loadingAction.hideLoading());
  // };
  const fetchData = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    function compareArea(a, b) {
      if (a.OVERUSE_AREA < b.OVERUSE_AREA) {
        return -1;
      }
      if (a.OVERUSE_AREA > b.OVERUSE_AREA) {
        return 1;
      }
      return 0;
    }
    dispatch(loadingAction.showLoading());
    try {
      let [res1, res2, res3, res4, minMaxTotal, minMaxEast, minMaxWest,] =
        await Promise.all([
          post(GET_RP_OVERUSE_SHIPPER, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
            OVERUSESHIPPER_PID: dropDownShipper.value,
          }),
          post(GET_RP_BALANCE, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
            BALANCECOLUMN_PID: dropDownShipper.value,
          }),
          post(GET_RP_BALANCE, {
            REPORT_DATE: moment(props.date).format("YYYY-MM-DD"),
            BALANCECOLUMN_PID: dropDownShipper.value,
          }),
          post(GET_RP_OVERUSE_CODE_DATA, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
            OVERUSECODE_PID: dropDownShipper.OVERUSECODE_PID
          }),

          post(GET_RP_BALANCE_TOTAL, {}),
          post(GET_RP_BALANCE_EAST, {}),
          post(GET_RP_BALANCE_WEST, {}),
        ]);

      setMinMaxTotalList(
        minMaxTotal.data.rpBalancingTotalList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );
      setMinMaxWestList(
        minMaxWest.data.rpBalancingWestList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );
      setMinMaxEastList(
        minMaxEast.data.rpBalancingEastList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );

      let dataByContact = res4.data.rpOveruseCodeDataList.map(row => ({
        ...row,
        OVERUSE_ACTUAL: Math.round(row.OVERUSE_ACTUAL/1000),
        OVERUSE_BOOKING: Math.round(row.OVERUSE_BOOKING/1000),
        OVERUSE:Math.round(row.OVERUSE_ACTUAL/1000 )> Math.round(row.OVERUSE_BOOKING/1000 )? Math.round(row.OVERUSE_ACTUAL/1000 )-Math.round(row.OVERUSE_BOOKING/1000 ):0,
      }))

      let data = res1.data.RPOversureShipperList.map(row => ({
        ...row,
        OVERUSE_ACTUAL: Math.round(row.OVERUSE_ACTUAL/1000),
        OVERUSE_BOOKING: Math.round(row.OVERUSE_BOOKING/1000),
        OVERUSE: Math.round(row.OVERUSE_ACTUAL/1000 )> Math.round(row.OVERUSE_BOOKING/1000 )? Math.round(row.OVERUSE_ACTUAL/1000) - Math.round(row.OVERUSE_BOOKING/1000) : 0,
      }));
      let balancing = res2.data.rpBalancingList;
      let graphData = res3.data?.rpBalancingList;
      if (graphData) {
        setBalancingGraphData(graphData);
      } else {
        setBalancingGraphData([]);
      }

      let balancingEast = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "east"
      );
      let balancingWest = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "west"
      );
      let balancingTotal = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "total"
      );

      // console.log(balancingEast)
      // console.log(balancingWest)
      // console.log(balancingTotal)



      let dataRangeCriteriaEast = minMaxEast.data.rpBalancingEastList.find(item => {
        // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
        // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
        if (moment(item.END_DATE).toDate() >= moment(props.date).toDate() && moment(item.START_DATE).toDate() <= moment(props.date).toDate()) {
          return true;
        } else if (moment(item.START_DATE).toDate() <= moment(props.date).toDate() && item.END_DATE == "" || item.END_DATE == null) {
          return true;
        }
        return false;
      });

      let dataRangeCriteriaWest = minMaxWest.data.rpBalancingWestList.find(item => {
        // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
        // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
        if (moment(item.END_DATE).toDate() >= moment(props.date).toDate() && moment(item.START_DATE).toDate() <= moment(props.date).toDate()) {
          return true;
        } else if (moment(item.START_DATE).toDate() <= moment(props.date).toDate() && item.END_DATE == "" || item.END_DATE == null) {
          return true;
        }
        return false;
      });

      let dataRangeCriteriaTotal = minMaxTotal.data.rpBalancingTotalList.find(item => {
        // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
        // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
        if (moment(item.END_DATE).toDate() >= moment(props.date).toDate() && moment(item.START_DATE).toDate() <= moment(props.date).toDate()) {
          return true;
        } else if (moment(item.START_DATE).toDate() <= moment(props.date).toDate() && item.END_DATE == "" || item.END_DATE == null) {
          return true;
        }
        return false;
      });

      setDataCriteriaTotal( {min:dataRangeCriteriaTotal.BALANCE_MIN,max:dataRangeCriteriaTotal.BALANCE_MAX});
      // console.log(dataRangeCriteriaTotal.BALANCE_MAX);

      setDataCriteriaWest({min:dataRangeCriteriaWest.BALANCE_MIN,max:dataRangeCriteriaWest.BALANCE_MAX});
      // console.log(dataRangeCriteriaWest.BALANCE_MAX);

      setDataCriteriaEast({min:dataRangeCriteriaEast.BALANCE_MIN,max:dataRangeCriteriaEast.BALANCE_MAX});
      // console.log(dataRangeCriteriaEast.BALANCE_MAX);

      if (balancingEast) {
        setBalancingOnshoreEast(balancingEast);
      } else {
        setBalancingOnshoreEast({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
        });
      }
      if (balancingWest) {
        setBalancingOnshoreWest(balancingWest);
      } else {
        setBalancingOnshoreWest({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
        });
      }
      if (balancingTotal) {
        setBalancingOnshoreTotal(balancingTotal);
      } else {
        setBalancingOnshoreTotal({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
        });
      }

      let contactList = [...new Set(dataByContact.map(item => item.OVERUSE_CONTACTCODE.trim()))].sort();
      let entry = dataByContact.filter(item => item.OVERUSE_POINT.toLowerCase() == 'entry').sort(compare);
      let exit = dataByContact.filter(item => item.OVERUSE_POINT.toLowerCase() == 'exit').sort(compare)

      let byContactEntryData = entry.sort(compare).reduce((r, a, index) => {
        let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA)
        if (prevData != undefined) {
          r.map(row => {
            if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
              row.data = [...row.data, a]
            }
            return row
          })
        } else {
          r.push({ OVERUSE_AREA: a.OVERUSE_AREA, data: [a], PRIORITY_FLAG: a.PRIORITY_FLAG })
        }

        return r;
      }, []).sort(compareArea)
      let tempEntryTotal = entry.sort(compare).reduce((r, a) => {

        r[a.OVERUSE_CONTACTCODE.trim()] = [...r[a.OVERUSE_CONTACTCODE.trim()] || [], a];
        return r;
      }, {})
      let entryTotal = []
      Object.keys(tempEntryTotal).map(key => {
        let temp = tempEntryTotal[key].reduce((total, row) => {

          total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING
          total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL
          total.OVERUSE = total.OVERUSE + row.OVERUSE
          total.PRIORITY_FLAG = tempEntryTotal[key][0].OVERUSE_CONTACTCODE.trim()
          return total
        }, { OVERUSE_BOOKING: 0, OVERUSE_ACTUAL: 0, OVERUSE: 0, PRIORITY_FLAG: 0 })
        entryTotal.push(temp)
      })
      let exitDataByContact = exit.sort(compare).reduce((r, a, index) => {
        let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA)
        if (prevData != undefined) {
          r.map(row => {
            if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
              row.data = [...row.data, a]
            }
            return row
          })
        } else {
          r.push({ OVERUSE_AREA: a.OVERUSE_AREA, data: [a], PRIORITY_FLAG: a.PRIORITY_FLAG })
        }

        return r;
      }, []).sort(compareArea)
      let tempExitTotal = exit.sort(compare).reduce((r, a) => {
        r[a.OVERUSE_CONTACTCODE.trim()] = [...r[a.OVERUSE_CONTACTCODE.trim()] || [], a];
        return r;
      }, {})
      let exitTotal = []
      Object.keys(tempExitTotal).map(key => {
        let temp = tempExitTotal[key].reduce((total, row) => {
          total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING
          total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL
          total.OVERUSE = total.OVERUSE + row.OVERUSE
          total.PRIORITY_FLAG = tempExitTotal[key][0].OVERUSE_CONTACTCODE.trim()
          return total
        }, { OVERUSE_BOOKING: 0, OVERUSE_ACTUAL: 0, OVERUSE: 0, PRIORITY_FLAG: 0 })
        exitTotal.push(temp)
      })
      let contactCountList = data.map((item) => contactList.length)

      let contactCountMax = 0
      if (contactCountList.length) contactCountMax = Math.max(...contactCountList)
      setContactCount(contactCountMax)



      let shipperList = data.map((item, index) => ({
        SHIPPER_NAME: item.OVERUSESHIPPER_NAME,
        PID: item.OVERUSESHIPPER_PID,
        PRIORITY_FLAG: item.OVERUSESHIPPER_ORDER,
      }));
      shipperList = [
        ...new Map(shipperList.map(item => [item["PID"], item])).values(),
      ];

      let entryData = data.filter(
        item => item.OVERUSE_POINT.toLowerCase() == "entry"
      );
      let exitData = data.filter(
        item => item.OVERUSE_POINT.toLowerCase() == "exit"
      );

      let entryDataList = entryData.map(row => {
        let obj = shipperList.find(
          shipper => shipper.PID == row.OVERUSESHIPPER_PID
        );
        return {
          ...row,
          ...(obj && { SHIPPER_PRIORITY_FLAG: obj.PRIORITY_FLAG }),
        };
      });
      let exitDataList = exitData.map(row => {
        let obj = shipperList.find(
          shipper => shipper.PID == row.OVERUSESHIPPER_PID
        );
        return {
          ...row,
          ...(obj && { SHIPPER_PRIORITY_FLAG: obj.PRIORITY_FLAG }),
        };
      });

      setOveruseDataEntry(
        entryDataList.sort(compareArea).reduce((r, a) => {
          r[a.OVERUSE_AREA] = [...(r[a.OVERUSE_AREA] || []), a];
          return r;
        }, {})
      );
      setOveruseDataExit(
        exitDataList.sort(compareArea).reduce((r, a) => {
          r[a.OVERUSE_AREA] = [...(r[a.OVERUSE_AREA] || []), a];
          return r;
        }, {})
      );
      let total1 = entryDataList.sort(compare).reduce((r, a) => {
        r[a.OVERUSESHIPPER_PID] = [...(r[a.OVERUSESHIPPER_PID] || []), a];
        return r;
      }, {});

      let total2 = exitDataList.sort(compare).reduce((r, a) => {
        r[a.OVERUSESHIPPER_PID] = [...(r[a.OVERUSESHIPPER_PID] || []), a];
        return r;
      }, {});
      let totalData1 = [];
      Object.keys(total1).map(key => {
        let temp = total1[key].reduce(
          (total, row) => {
            total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING;
            total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL;
            total.OVERUSE = total.OVERUSE + row.OVERUSE;
            total.SHIPPER_PRIORITY_FLAG = total1[key][0].SHIPPER_PRIORITY_FLAG;
            return total;
          },
          {
            OVERUSE_BOOKING: 0,
            OVERUSE_ACTUAL: 0,
            OVERUSE: 0,
            SHIPPER_PRIORITY_FLAG: 0,
            SHIPPER_PID: "",
          }
        );
        totalData1.push(temp);
      });

      let totalData2 = [];
      Object.keys(total2).map(key => {
        let temp = total2[key].reduce(
          (total, row) => {
            total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING;
            total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL;
            total.OVERUSE = total.OVERUSE + row.OVERUSE;
            total.SHIPPER_PRIORITY_FLAG = total2[key][0].SHIPPER_PRIORITY_FLAG;
            return total;
          },
          {
            OVERUSE_BOOKING: 0,
            OVERUSE_ACTUAL: 0,
            OVERUSE: 0,
            SHIPPER_PRIORITY_FLAG: 0,
          }
        );
        totalData2.push(temp);
      });


      setOveruseDataByContact([{ SHIPPER_NAME: dropDownShipper.label, contacts: contactList, entry: byContactEntryData, entryTotal: entryTotal, exit: exitDataByContact, exitTotal: exitTotal }])
      setTotal({ entry: totalData1, exit: totalData2 });
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  return (
    <Row>

      <Row className="mt-0">
        <Col sm="6">
          <h5 className="mb-0 sm-0" style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}>
            Shipper Summary
          </h5>
        </Col>
        <Col sm="6">
          <h5
            className="mb-0 sm-0 d-flex align-items-center justify-content-end"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Gas Day : {moment(props.date).locale("en").format("DD MMM YYYY")}

          </h5>
        </Col>
      </Row>

      <Row className="mt-2">
        <hr />
      </Row>

      <div className="d-flex dashboard-content-body">

        <div className="d-flex" style={{ flex: 1, paddingRight: 2 }}>
          <div className="d-flex flex-column" style={{ flex: 1 }}>

            <div className="d-flex" style={{ flex: 1 }}>
              <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                <h5 style={{ fontSize: "1.9vh", fontWeight: "bold" }}>Onshore Balancing</h5>
                <Table
                  className="table table-bordered mb-0"
                >
                  <thead style={{ fontSize: "1.7vh", fontWeight: "bold" }}>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#5868b785",
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      ></th>
                      <th
                        style={{
                          backgroundColor: "#466597", //667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Entry
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597", //5868b785
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Exit
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597", //667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Balancing
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold" }}>
                    <tr>
                      <td>East</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreEast.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(balancingOnshoreEast.BALANCING_EXIT / 1000, 0)}
                      </td>

                      <td style={{ color: (balancingOnshoreEast.BALANCING_BALANCE > dataCriteriaEast.max||balancingOnshoreEast.BALANCING_BALANCE<dataCriteriaEast.min)? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(balancingOnshoreEast.BALANCING_BALANCE, 1)} %
                      </td>
                    </tr>
                    <tr>
                      <td>West</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreWest.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(balancingOnshoreWest.BALANCING_EXIT / 1000, 0)}
                      </td>

                      <td style={{ color:  (balancingOnshoreWest.BALANCING_BALANCE > dataCriteriaWest.max||balancingOnshoreWest.BALANCING_BALANCE<dataCriteriaWest.min) ? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(balancingOnshoreWest.BALANCING_BALANCE, 1)} %
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreTotal.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(
                          balancingOnshoreTotal.BALANCING_EXIT / 1000
                          , 0)}
                      </td>

                      <td style={{ color:  (balancingOnshoreTotal.BALANCING_BALANCE > dataCriteriaTotal.max||balancingOnshoreTotal.BALANCING_BALANCE<dataCriteriaTotal.min) ? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        
                        {numberFormat(balancingOnshoreTotal.BALANCING_BALANCE, 1)}%
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <div className="mt-0" style={{ width: '100%', position: 'relative', height: "70%", margin: 0 }}>
                  {/* //margin: 'auto' */}
                  <ChartOnshore
                    // balancingGraphData={balancingGraphData.filter(
                    //   item => item.BALANCING_ZONE.toLowerCase() == "total"
                    // )}
                    balancingGraphData={balancingGraphData}
                    minMax={minMaxTotalList}
                    date={props.date}
                    summaryReportPid={props.summaryReportPid}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex" style={{ flex: 0.2 }}>
              <div className="d-flex flex-column align-items-center" style={{ width: "100%", position: 'relative' }}>
                <Input
                  readOnly
                  type="textarea"
                  rows="2"
                  style={{
                    border: "solid 1px #FFFFFF",
                    color: "#FFFFFF",
                    resize: "none",
                    width: "93%",
                  }}
                  className="form-control"
                  value={balancingOnshoreTotal.BALANCING_REMARK}
                />
              </div>
            </div>

          </div>
        </div>


        <div className="d-flex" style={{ flex: 1, borderLeft: "solid 2px #4A5576", paddingLeft: 2 }}>
          <div className="d-flex flex-column" style={{ flex: 1 }}>

            <div className="d-flex" style={{ flex: 1 }}>
              <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                <FormGroup className="row">
                  <Col sm={3}>
                    <h5 style={{ fontSize: "1.9vh", fontWeight: "bold" }}>Capacity Overuse</h5>
                  </Col>
                  <Col sm={5}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="FLAG_SHOW_TABLE"
                      id="esc1"
                      checked={flagShowContact.FLAG_SHOW_TABLE == 0}
                      onChange={() =>
                        setFlagShowContact({
                          ...flagShowContact,
                          FLAG_SHOW_TABLE: 0,
                        })
                      }
                    />
                    <label
                      className="form-check-label ms-1"
                      style={{ color: "#FCFF33", fontWeight: "bold", fontSize: "1.8vh" }}
                      htmlFor="esc1"
                    >
                      By Shipper
                    </label>
                    <input
                      className="form-check-input ms-3"
                      type="radio"
                      id="esc2"
                      name="AVGDEMAND_STATUS"
                      checked={flagShowContact.FLAG_SHOW_TABLE == 1}
                      onChange={() =>
                        setFlagShowContact({
                          ...flagShowContact,
                          FLAG_SHOW_TABLE: 1,
                        })
                      }
                    />
                    <label
                      className="form-check-label ms-1"
                      style={{ color: "#64FF33", fontWeight: "bold", fontSize: "1.8vh" }}
                      htmlFor="esc2"
                    >
                      By Contact
                    </label>
                  </Col>
                  <Label className="col-sm-1 col-form-label d-flex align-items-center justify-content-end" style={{ color: "#FFFFFF", fontWeight: "bold" }}>
                    Shipper
                  </Label>
                  <Col sm={3}>
                    <Select
                      placeholder="No publlic data"
                      isClearable={false}
                      value={dropDownShipper}
                      onChange={handleSelectDropDownShipper}
                      options={listShipper}
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                </FormGroup>

                {flagShowContact.FLAG_SHOW_TABLE == 0 && (

                  <OveruseByShipper
                    shipper={dropDownShipper}
                    overuseDataEntry={overuseDataEntry}
                    overuseDataExit={overuseDataExit}
                    total={total}
                  />

                )}

                {flagShowContact.FLAG_SHOW_TABLE == 1 && (

                  <OveruseByContact overuseData={overuseDataByContact} contactCount={contactCount} shipper={dropDownShipper} />

                )}

              </div>
            </div>

          </div>
        </div>

      </div>

      {/* <div className="d-flex dashboard-content-body">
        <div className="d-flex flex-column" style={{ flex: 1.5 }}>
          <div className="d-flex" style={{ flex: 1, margin: 5, position: "relative" }}>
            <div style={{ width: '50%', borderRight: "2px solid #4A5576", }} className="mt-0">
              <div style={{ width: '100%', paddingRight: "0.3vw" }} className="mt-0">

                <h5 style={{ fontSize: "1.8vh", fontWeight: "bold" }}>Onshore Balancing</h5>
                <Table
                  className="table table-bordered mb-0"
                >
                  <thead style={{ fontSize: "1.7vh", fontWeight: "bold" }}>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#5868b785",
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      ></th>
                      <th
                        style={{
                          backgroundColor: "#466597", //667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Entry
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597", //5868b785
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Exit
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597", //667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Balancing
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold" }}>
                    <tr>
                      <td>East</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreEast.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(balancingOnshoreEast.BALANCING_EXIT / 1000, 0)}
                      </td>

                      <td style={{ color: balancingOnshoreEast.BALANCING_BALANCE > dataCriteriaEast ? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(balancingOnshoreEast.BALANCING_BALANCE, 0)} %
                      </td>
                    </tr>
                    <tr>
                      <td>West</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreWest.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(balancingOnshoreWest.BALANCING_EXIT / 1000, 0)}
                      </td>

                      <td style={{ color: balancingOnshoreWest.BALANCING_BALANCE > dataCriteriaWest ? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(balancingOnshoreWest.BALANCING_BALANCE, 0)} %
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreTotal.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(
                          balancingOnshoreTotal.BALANCING_EXIT / 1000
                          , 0)}
                      </td>

                      <td style={{ color: balancingOnshoreTotal.BALANCING_BALANCE > dataCriteriaTotal ? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(balancingOnshoreTotal.BALANCING_BALANCE, 0)}%
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <div style={{ width: '100%', position: 'relative', margin: 'auto', paddingRight: "0.3vw", height: '50%' }} className="mt-0">
                <ChartOnshore
                  // balancingGraphData={balancingGraphData.filter(
                  //   item => item.BALANCING_ZONE.toLowerCase() == "total"
                  // )}
                  balancingGraphData={balancingGraphData}
                  minMax={minMaxTotalList}
                  date={props.date}
                  summaryReportPid={props.summaryReportPid}
                />
                <div className="d-flex flex-column align-items-center">
                  <Input
                    readOnly
                    type="textarea"
                    rows="2"
                    style={{
                      border: "solid 1px #FFFFFF",
                      color: "#FFFFFF",
                      resize: "none",
                      width: "93%",
                    }}
                    className="form-control"
                    value={balancingOnshoreTotal.BALANCING_REMARK}
                  />
                </div>
              </div>
            </div>
            <div style={{ width: '50%' }} className="mt-0 ms-2">
              <FormGroup className="row">
                <Col sm={4}>
                  <h5 style={{ color: "#FFFFFF" }}>Capacity Overuse</h5>
                </Col>
                <Label className="col-sm-2 col-form-label d-flex align-items-center justify-content-end">
                  Shipper
                </Label>
                <Col sm={6}>
                  <Select
                    placeholder="No publlic data"
                    isClearable={false}
                    value={dropDownShipper}
                    onChange={handleSelectDropDownShipper}
                    options={listShipper}
                    classNamePrefix="select2-selection"
                  />
                </Col>
              </FormGroup>
              <div style={{ width: "100%" }}>
                <OveruseByShipper
                  shipper={dropDownShipper}
                  overuseDataEntry={overuseDataEntry}
                  overuseDataExit={overuseDataExit}
                  total={total}
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}


    </Row >
  );
}

SectionCapacityOveruse.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SectionCapacityOveruse;
